import { Pipe, PipeTransform } from '@angular/core';
import { MetaService } from '@bo-client/core/api/meta-service';
import { map } from 'rxjs';

@Pipe({
  name: 'isPerson'
})
export class IsPersonPipe implements PipeTransform {
  constructor(private metaService: MetaService) {}

  transform(value: any) {
    return this.metaService.salutationValues$.pipe(
      map((salutationValues) => {
        return salutationValues.find((x) => x.id === value)?.type.toLowerCase() === 'person';
      })
    );
  }
}

@Pipe({
  name: 'salutationTitle'
})
export class SalutationTitlePipe implements PipeTransform {
  constructor(private metaService: MetaService) {}

  transform(value: any) {
    return this.metaService.salutationValues$.pipe(
      map((salutationValues) => {
        return salutationValues.find((x) => x.id === value)?.title;
      })
    );
  }
}
